(ns common.schema.entities.ai-document-generation.schema
  (:require
   [common.schema.entities.ai-summary-configuration.options :as configuration-options]
   [common.schema.entities.integration.ai-options :as ai-options]
   [common.schema.schema-utils :as su]))

(defn- system-controlled
  [opts]
  (assoc opts :system-semantics su/system-controlled-optional-field-semantics))

(def schema
  (vec
   (concat
    (su/single-ref-field :ai-document-generation/requested-by
                         "Requested by"
                         [:entity.type/account]
                         (system-controlled {:authorization su/access-system-user}))
    (su/single-ref-field :ai-document-generation/source-deal
                         "Source deal"
                         [:entity.type/oppo]
                         (system-controlled {:authorization su/access-system-user}))
    ;; Purpose: Records the library configuration selected for this run.
    ;; Justification: It preserves provenance while the mutable configuration
    ;; may later be edited or disabled.
    ;; Special instructions: Capture only after rechecking tenant, sharing, and
    ;; pipeline applicability. The worker must use the snapshots below instead
    ;; of rereading mutable configuration settings.
    (su/single-ref-field :ai-document-generation/summary-configuration
                         "AI summary configuration"
                         [:entity.type/ai-summary-configuration]
                         (system-controlled {:authorization su/access-system-user}))
    ;; Purpose: Freezes the selected configuration's task instructions for the
    ;; asynchronous run.
    ;; Justification: Queued work must not change if its configuration is edited.
    ;; Special instructions: Maximum 20,000 characters. Place inside the
    ;; protected prompt envelope; it cannot replace safety or output rules.
    (su/text-multiline-field
     :ai-document-generation/summary-instructions
     "AI summary instruction snapshot"
     (system-controlled
      {:authorization su/access-system-user
       :constraints {:constraint/string-max-length 20000}}))
    ;; Purpose: Freezes the independently selected context branches for this run.
    ;; Justification: Context collection must remain stable while queued.
    ;; Special instructions: Validate against the shared source registry and
    ;; apply before loading activity or extracting attachment content. Empty
    ;; means the provider receives no optional record-context branches.
    (su/keyword-multi-field
     :ai-document-generation/selected-data-sources
     "AI summary data-source snapshot"
     configuration-options/data-source-options
     (system-controlled {:authorization su/access-system-user}))
    ;; Purpose: Freezes bounded imported brand/style guidance for this run.
    ;; Justification: Generation must not reread a document or crawl a URL.
    ;; Special instructions: Maximum 20,000 characters; treat as untrusted style
    ;; reference content, never log it, and never expose it from status APIs.
    (su/text-multiline-field
     :ai-document-generation/imported-style-guidelines
     "AI summary style-guideline snapshot"
     (system-controlled
      {:authorization su/access-system-user
       :constraints {:constraint/string-max-length 20000}}))
    (su/keyword-field :ai-document-generation/task-type
                      "Task type"
                      ai-options/task-type-options
                      (system-controlled {:authorization su/access-system-user}))
    (su/keyword-field :ai-document-generation/generation-status
                      "Generation status"
                      ai-options/status-options
                      (system-controlled {:authorization su/access-system-user}))
    (su/single-ref-field :ai-document-generation/service
                         "AI service"
                         [:entity.type/ai-service]
                         (system-controlled {:authorization su/access-system-user}))
    (su/single-ref-field :ai-document-generation/task-config-override
                         "Task configuration override"
                         [:entity.type/ai-task-config-override]
                         (system-controlled {:authorization su/access-system-user}))
    (su/single-ref-field :ai-document-generation/template-attachment
                         "Template attachment"
                         [:entity.type/attachment]
                         (system-controlled {:authorization su/access-system-user}))
    (su/url-field :ai-document-generation/style-reference-url
                  "Style reference URL"
                  (system-controlled {:authorization su/access-system-user}))
    (su/single-ref-field :ai-document-generation/output-attachment
                         "Output attachment"
                         [:entity.type/attachment]
                         (system-controlled {:authorization su/access-system-user}))
    (su/keyword-field :ai-document-generation/failure-category
                      "Failure category"
                      nil
                      (system-controlled {:authorization su/access-system-user}))
    (su/text-simple-field :ai-document-generation/prompt-version
                          "Prompt version"
                          (system-controlled {:authorization su/access-system-user})))))
